export default {
  frontpage: 'Frontpage',
  channel: 'Channel',
  category: 'Category',
  article: 'Article',
  articleComments: 'Comments',
  other: 'Other',
} as Record<string, string>;
